import { IGoogleAnalytics } from './../resources/services/google-analytics';
import { AppTask } from 'aurelia';
export const GoogleAnalyticsTask = AppTask.activating(IGoogleAnalytics, (ga) => {
    ga.init('UA-44935027-5');
    ga.attach();
});
